/**
 * "Tonya Drees" -> "TD".
 *
 * Shown in the header instead of a generic person icon: on a shared office
 * machine, whose session this is matters, and initials answer that at a glance
 * where an avatar silhouette does not.
 */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)

  if (words.length === 0) return '?'

  // First and last, so "Jersey Grace Petross" reads JP rather than JG — the
  // surname is what distinguishes two people who share a first name, and this
  // studio has two Ashleys (D-82).
  const first = words[0][0]
  const last = words.length > 1 ? words[words.length - 1][0] : ''

  return (first + last).toUpperCase()
}
